<template>
    <div class="type mt-4 position-relative">
        <ldc-select
            v-model="new_old"
            placeholder="Chọn trạng thái"
            class="rv-select-form" v-if="$detect == 'web'">
            <ldc-option
                :value="0"
                label="Mới 100%"/>
            <ldc-option
                :value="1"
                label="Đã qua sử dụng"/>
        </ldc-select>
        <ldc-select-mobile
            :showPlaceholder="false"
            placeholder="Chọn trạng thái"
            title="Loại tin"
            v-model="new_old"
            class="select-mobile-post"
            v-else>
            <ldc-option-mobile
                :value="0"
                label="Mới 100%"/>
            <ldc-option-mobile
                :value="1"
                label="Đã qua sử dụng"/>
        </ldc-select-mobile>
        <div class="text-position-select position-absolute text-primary">Trạng thái</div>
    </div>
</template>
<script>
export default {
    props: ['data'],
    data() {
        return {
            new_old: ''
        }
    },
    watch: {
        data(val){
            this.new_old = val;
        },
        new_old(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.new_old = this.data;
    }
}
</script>
